
  import { computed, defineComponent, PropType } from 'vue';
  import { Colour, getFeatureColourFromBackground, getForegroundColourFromBackground } from '../../../helpers/colour';
  import TpxDivider from '../../atoms/divider/divider.vue';
  import TpxListingItem, { ListingImageHoverEffect } from './listing-item.vue';
  import TpxParagraph from '../../atoms/type/paragraph.vue';
  import './listing.scss';

  /**
   * Listings molecule
   * 
   * @example
   * <code>import TpxListing from '@manifesto-tech/tpximpact-design-system/components/molecules/listing/listing.vue'</code>
   */
  export default defineComponent({
    name: 'TpxListing',
    
    components: {
      TpxDivider,
      TpxListingItem,
      TpxParagraph,
    },

    props: {
      /**
       * Background colour
       * Used to work out what the feature colour for dividers, headers and icons should be
       */
      backgroundColour: {
        default: Colour.White,
        type: String,
        validator: (value) => {
          return Object.values(Colour).includes(value as Colour);
        },
      },

      /**
       * Listing items to be displayed within this list
       */
      items: {
        type: Array as PropType<Array<typeof TpxListingItem>>,
      },

      /**
       * No results message
       */
      noResultsMessage: {
        default: 'No results',
        type: String,
      },
    },

    data() {
      return {
        colourClasses: computed(() => ({
          [`bg--${this.backgroundColour}`]: !!this.backgroundColour,
          [`text--${getForegroundColourFromBackground(this.backgroundColour)}`]: !!this.backgroundColour,
        })),
        featureColour: getFeatureColourFromBackground(this.backgroundColour),
      };
    },
  });
